import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";

import { AiReviewCounts } from "../../aiReview.types";
import { AI_REVIEW_QUERY_KEY } from "../../constants/enums";
import { AI_REVIEW } from "../../constants/review";
import { requestGetReviewCount } from "./getReviewCount.request";

// The sidebar badge. There is no socket for review items, so it polls; every
// review mutation invalidates the AI_REVIEW_QUERY_KEY prefix, which refreshes
// it at once. It never shows an error: a backend without the route reads as 0.
const useGetReviewCount = ({ enabled }: { enabled?: boolean } = {}) =>
  useQuery<AiReviewCounts, ApiServiceError<ApiError>>({
    queryKey: [AI_REVIEW_QUERY_KEY, "count"],
    queryFn: async () => await requestGetReviewCount(),
    enabled: enabled ?? true,
    refetchInterval: AI_REVIEW.COUNT_POLL_MS,
    meta: { preventDefaultNotFound: true, preventDefaultBadRequest: true }
  });

export default useGetReviewCount;
